import { Batch } from "@wingspanhq/wingspan-api-sdk";

import { selectorImportBatchNames } from "./selectorImportBatchNames";

type Args = {
  batch: Batch;
  /** Singular noun for what the batch imports, e.g. "Payable", "Contractor". */
  entityLabel: string;
};

/**
 * Line under the batch name in the batches list: the note the user left on the
 * batch, falling back to the spreadsheet it was filled from.
 */
export const selectorImportBatchNameSecondaryText = (
  args: Args
): string | undefined => {
  const notes = args.batch.notes?.trim();

  return notes
    ? `Note: ${notes}`
    : selectorImportBatchNames(args).batchFileName;
};
